import { cn } from "@/lib/utils";

// Static class strings so Tailwind's JIT picks them up (no dynamic interpolation).
const GRID_COLS: Record<number, string> = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  7: "grid-cols-7",
  8: "grid-cols-8"
};
const GRID_COLS_MD: Record<number, string> = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
  5: "md:grid-cols-5",
  6: "md:grid-cols-6",
  7: "md:grid-cols-7",
  8: "md:grid-cols-8"
};
type Props = {
  label: string;
  description?: string;
  photos: string[];
  /** Columns on mobile (and up if columnsMd is not set). Defaults to 4. */
  columns?: number;
  /** Columns from the md breakpoint up. Defaults to `columns`. */
  columnsMd?: number;
};
export function PhotoPreviewGroup({
  label,
  description,
  photos,
  columns = 4,
  columnsMd
}: Props) {
  if (photos.length === 0) return null;
  return <div className="flex flex-col gap-2" data-sentry-component="PhotoPreviewGroup" data-sentry-source-file="PhotoPreviewGroup.tsx">
      <p className="text-sm font-medium text-foreground">{label}</p>
      {description && <p className="text-xs text-muted-foreground">{description}</p>}
      <div className={cn("grid gap-2", GRID_COLS[columns], columnsMd && GRID_COLS_MD[columnsMd])}>
        {photos.map(url => <img key={url} src={url} alt="" className="aspect-square w-full cursor-default rounded-lg object-cover" />)}
      </div>
    </div>;
}